//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";
import { openDB } from "idb";
import moment from "moment";
import { mapActions, mapMutations } from "vuex";
export default {
  data: () => ({
    showSnackbar: false,
    snackbarMessage: "",
    snackbarColor: "error",
    showBusyAni: false,
    dlgInfo: false,
    dlgMessage: "",
    db: null,

    offlineRandCount: 0,
    offlinePostRandCount: 0,
    postRandCRFs: [],
    offlineRands: [],
    isOffline: true,
    appUserId: "",
    accountRevoked: false,
  }),
  computed: {
    btnSyncDisableStatus() {
      return (
        this.isOffline ||
        (this.offlineRandCount == 0 && this.offlinePostRandCount == 0)
      );
    },
  },
  methods: {
    ...mapMutations(["setCrfTitle"]),
    ...mapActions([
      "clientIsOffline",
      "fetchRandomisationCount",
      "fetchAllOfflineRandomisations",
      "fetchAppUserId",
      "clearAllOfflineRandomisations",
      "noSyncInProgress",
    ]),
    async syncOfflineData() {
      this.showBusyAni = true;
      await this.getSites();
      if (this.accountRevoked) {
        return;
      }
      if (await this.noSyncInProgress()) {
        if (this.offlineRandCount != 0) {
          await this.uploadOfflineRandomisations();
        }
        if (this.offlinePostRandCount != 0) {
          await this.uploadPostRandCRFs();
        }
        //reset sync status
        const db = await openDB("AIRWAYS3idb");
        await db
          .transaction("tbSettings", "readwrite")
          .objectStore("tbSettings")
          .put({ state: 0, lastSyncDate: moment().format() }, "syncSatus");
      }
      this.offlineRandCount = 0;
      this.offlinePostRandCount = 0;
      this.snackbarColor = "success";
      this.snackbarMessage = "sync completed successfully!";
      this.showSnackbar = true;

      this.showBusyAni = false;
    },
    async uploadOfflineRandomisations() {
      this.offlineRands = await this.fetchAllOfflineRandomisations();
      const fdata = {
        appUserId: this.appUserId,
        clientActivityType: "MANUAL-OFFLINE-RANDOMISATIONS-UPLOAD",
        offlineRands: this.offlineRands,
      };
      this.showBusyAni = true;
      const actionUrl = `${process.env.BASE_URL}Randomisation/SyncOfflineRandomisations`;
      try {
        const {
          data: { rstatus, activeSites },
        } = await axios.post(actionUrl, fdata);

        if (rstatus == 0) {
          await this.db
            .transaction("tbSettings", "readwrite")
            .objectStore("tbSettings")
            .put(activeSites, "sites");

          await this.clearAllOfflineRandomisations();
          this.offlineRandCount = 0;
        }
        this.showBusyAni = false;
      } catch (error) {
        this.showBusyAni = false;

        this.dlgMessage =
          "Sorry, we are having some technical issues. Please email airways3@warwick.ac.uk quoting error description: OFFLINE-RANDS-FAILED-TO-UPLOAAD@FrmSyncData";
        this.dlgInfo = true;

        throw error;
      }
    },
    async uploadPostRandCRFs() {
      if (this.postRandCRFs.length == 0) return;

      const pdata = {
        appUserId: this.appUserId,
        clientActivityType: "MANUAL-OFFLINE-POST-RAND-CRFs-UPLOAD",
        postRandCRFs: this.postRandCRFs,
      };

      this.showBusyAni = true;
      const actionUrl = `${process.env.BASE_URL}Randomisation/SavePostRandCRFs`;
      try {
        const {
          data: { rstatus },
        } = await axios.post(actionUrl, pdata);

        if (rstatus == 0) {
          this.postRandCRFs.forEach(async (item) => {
            await this.db
              .transaction("tbPostRandCRF", "readwrite")
              .objectStore("tbPostRandCRF")
              .delete(item.tno);
          });
          this.offlinePostRandCount = 0;
        }
        this.showBusyAni = false;
      } catch (error) {
        this.showBusyAni = false;

        this.dlgMessage =
          "Sorry, we are having some technical issues. Please email airways3@warwick.ac.uk quoting error description: POST-RAND-CRFs-FAILED-TO-UPLOAAD@FrmSyncData";
        this.dlgInfo = true;

        throw error;
      }
    },
    onOKClickedDlgInfo() {
      this.$router.push("/");
    },
    async onChangeNetworkStatus(e) {
      const { type } = e;
      if (type === "online") {
        await this.resetSyncBtn();
      }
    },
    async resetSyncBtn() {
      this.offlineRandCount = await this.fetchRandomisationCount();
      this.postRandCRFs = (
        await this.db
          .transaction("tbPostRandCRF")
          .objectStore("tbPostRandCRF")
          .getAll()
      ).filter((p) => p && p.prd_DidPatientSurvivedTheCardiacArrest);

      this.offlinePostRandCount = this.postRandCRFs.length;
      this.isOffline = await this.clientIsOffline();
    },
    async getSites() {
      const actionUrl = `${process.env.BASE_URL}AppAuth/GetSites`;
      try {
        const {
          data: { rstatus, rdata },
        } = await axios.get(actionUrl, {
          params: { appUserId: this.appUserId },
        });
        if (rstatus == 0) {
          //save data to local idb
          this.accountRevoked = false;
          const db = await openDB("AIRWAYS3idb");
          const tx = db.transaction("tbSettings", "readwrite");
          const store = tx.objectStore("tbSettings");
          await store.put(rdata, "sites");
          await store.put(rdata[0].value, "defaultSite");
          await tx.done;
        } else if (rstatus == -2) {
          this.accountRevoked = true;
          this.snackbarColor = "error";
          this.snackbarMessage =
            "Sorry, we have noticed an issue with your account setup, please contact the Trial Team.";
          this.showSnackbar = true;
        }
      } catch (error) {
        this.snackbarColor = "error";
        this.snackbarMessage =
          "Sorry, we have noticed an issue with your account setup, please contact the Trial Team.";
        this.showSnackbar = true;
      }
    },
  },
  async mounted() {
    this.setCrfTitle("Sync data");
    this.appUserId = await this.fetchAppUserId();
    this.db = await openDB("AIRWAYS3idb");
    await this.resetSyncBtn();
    window.addEventListener("online", this.onChangeNetworkStatus);
  },
};
